import { ProductsState } from "../reducer/state";
import { useAppState } from "../../../appState";

export default function useProductsState(): ProductsState {
	return useAppState().products;
}
